import { useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import TransactionOverlay from '../../components/transactions/TransactionOverlay';
import QuotationsManage, {
  type QuotationsManageSaveReason,
} from '../sales/QuotationsManage';
import type { Quotation } from '../../types/sales/quotation';
import { useSalesTransactionsHub } from './SalesTransactionsHubContext';

const SalesQuotationOverlay = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { refetchList } = useSalesTransactionsHub();
  const listSearch = location.search.replace(/^\?/, '');

  const close = useCallback(() => {
    navigate({ pathname: '/sales-transactions', search: listSearch }, { preventScrollReset: true });
  }, [listSearch, navigate]);

  const isNew = id === 'new';
  const parsedId = id != null ? Number(id) : Number.NaN;
  const quotationId = isNew || Number.isNaN(parsedId) || parsedId <= 0 ? undefined : parsedId;

  const handleQuotationSaved = useCallback(
    (quotation: Quotation, reason: QuotationsManageSaveReason) => {
      refetchList();

      if (reason === 'created') {
        navigate(
          { pathname: `/sales-transactions/quotation/${quotation.id}`, search: listSearch },
          { replace: true, preventScrollReset: true }
        );
        return;
      }

      close();
    },
    [close, listSearch, navigate, refetchList]
  );

  return (
    <TransactionOverlay headerless variant="wide" onClose={close}>
      <QuotationsManage
        key={quotationId ?? 'new'}
        embedded
        quotationId={quotationId}
        onClose={close}
        onQuotationSaved={handleQuotationSaved}
      />
    </TransactionOverlay>
  );
};

export default SalesQuotationOverlay;
